import api from "@/lib/api";

const KEY = "hoh_mkt_session";
const seen = new Set();

export function sessionId() {
  let id = sessionStorage.getItem(KEY);
  if (!id) {
    id = (crypto.randomUUID && crypto.randomUUID()) || `${Date.now()}-${Math.random().toString(36).slice(2)}`;
    sessionStorage.setItem(KEY, id);
  }
  return id;
}

export function track(type, listing_id = null, destination = null) {
  if (type === "view") {
    if (seen.has(listing_id)) return;
    seen.add(listing_id);
  }
  api.post("/marketplace/track", { type, listing_id, destination, session_id: sessionId() }).catch(() => {});
}

export const resolveImg = (url) =>
  url && url.startsWith("/api/") ? `${process.env.REACT_APP_BACKEND_URL}${url}` : url;
